<div mat-dialog-content>
  <h2>Kanseller ordre</h2>

  <p>
    Er du sikker på at du ønsker å kansellere ordre
    <span class="order-id-text">#{{ orderServiceId }}</span>
    ?
  </p>

  <div class="container" [formGroup]="form">
    <mat-form-field appearance="outline">
      <mat-label>Begrunnelse</mat-label>
      <textarea
        cols="40"
        data-testid="cancel-order-reason-input"
        formControlName="reason"
        matInput
        maxlength="200"
        rows="5"
      ></textarea>
      @if (form.controls.reason.hasError('required')) {
        <mat-error>Vennligst skriv en kort tekst om hvorfor du kansellerer denne orderen.</mat-error>
      }
    </mat-form-field>
  </div>
</div>

<div mat-dialog-actions>
  <div class="buttons">
    <app-ice-button
      color="primary"
      testId="confirm-cancel-order-button"
      [disabled]="!(form.dirty && form.valid)"
      (click)="cancelOrder()"
    >
      Kanseller
    </app-ice-button>
    <app-ice-button color="outlined" matDialogClose testId="abort-cancel-order-button" (click)="abort()">
      Avbryt
    </app-ice-button>
  </div>
</div>
